<div class="card" [title]="name">
  <img class="card__image" [src]="imageSrc" alt="">
  @if (hasDefaultBackground) {
    <div class="default-image-background"></div>
  }

  <div class="card__content">
    <div class="card__text-wrapper">
      <h5 class="card__title">{{name}}</h5>
      <div class="card__position">{{title}}</div>
    </div>

    <div class="card__socials">
      @if (linkedin) {
        <div class="social-icon">
          <a href="{{linkedin}}" target="_blank">
            <img src="/assets/images/socials/linkedin-icon--white.svg" alt="">
          </a>
        </div>
      }

      @if (web) {
        <div class="social-icon social-icon--web">
          <a href="{{web}}" target="_blank">
            <i class="ion-link"></i>
          </a>
        </div>
      }

      @if (publications) {
        <div class="social-icon">
          <a href="{{publications}}" target="_blank">
            <img src="/assets/images/about-brainkey/icon.svg" alt="">
          </a>
        </div>
      }
    </div>
  </div>
</div>
